import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { toTitleCase } from "src/app/Module/executive/components/taxpayer-performance-dashboard/taxpayer-modal/taxpayer-modal.component";
import * as alertify from "alertifyjs";
import { phoneNumberValidator } from "src/app/Shared/phone-number.validator";
import { FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ApiServiceService } from "src/app/Services/api-service.service";
import { DatePipe } from "@angular/common";
@Component({
  selector: "app-individual-preview",
  templateUrl: "./individual-preview.component.html",
  styleUrls: ["./individual-preview.component.scss"],
  providers: [DatePipe],
})
export class IndividualPreviewComponent implements OnInit {
  previewUrl: string | ArrayBuffer = null;

  isLoading: boolean = false;
  basicForm: any;
  @Output() onSubmit = new EventEmitter<{}>();
  @Input() previewDetails: any;
  @Input() isSubmitting: boolean;
  @Output() goBack = new EventEmitter<void>();
  area: any[] = [];
  state2: any[] = [];
  lga2: any[] = [];
  area2: any[] = [];
  sourceOfIncome: any[] = [];
  years: any = [];
  assetsOptions = ["Land", "Livestock", "Houses", "Others", "Vehicles"];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private apiService: ApiServiceService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit() {
    this.basicForm = this.fb.group({
      title: ["", Validators.required],
      firstname: ["", Validators.required],
      lastname: ["", Validators.required],
      nin: [""],
      middlename: [""],
      dob: ["", Validators.required],
      nationality: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      phone: ["", Validators.required],
      gender: ["", Validators.required],
      highestEducation: ["", Validators.required],
      password: [
        "",
        [
          Validators.required,
          Validators.pattern(
            /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/,
          ),
        ],
      ],
      confirm_password: [
        "",
        [
          Validators.required,
          Validators.pattern(
            /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/,
          ),
        ],
      ],

      incomeCategory: [""],
      employerName: [""],
      incomeRange: [""],
      natureOfBusiness: [""],
      sourceOfIncome: [""],
      totalAnnualIncome: [""],
      closestTaxOffice: [""],
      hasVehicle: [""],
      numberOfVehicles: [null],
      hasProperty: [""],
      propertyType: [""],

      // CONTACT
      alternativeEmail: ["", [Validators.email]],
      state: [""],
      lga: [""],
      houseNumber: [""],
      streetName: [""],

      // RENT
      accommodationType: [""],
      buildingType: [""],
      rentPeriodCovered: [""],
      periodType: [""],
      propertyManagement: [""],
      annualRentAmount: [""],

      // LANDLORD
      landlordFullName: [""],
      landlordPhoneNumber: ["", phoneNumberValidator],
      asin: [""],
      landlordEmail: ["", Validators.email],
      doesLandlordLiveSameApartment: [""],
      landlordAddress: [""],
      landlordAsin: [""],

      // LIFESTYLE
      hasPurchasedAsset: [""],
      assetItems: [""],
    });

    const currentYear = new Date().getFullYear() + 1;
    const startYear = 1900; // or whatever lower limit you want
    for (let y = currentYear; y >= startYear; y--) {
      this.years.push(y);
    }

    this.patchForm();
    this.getState();
    this.getOccupation();
    this.getAllBusinessNature();
  }

  businessNatureList: any[];
  getAllBusinessNature() {
    this.apiService.LoginGet("/auth/utility/business_nature/all").subscribe(
      (reponse) => {
        this.businessNatureList = reponse;
      },
      (error) => {
        console.log(error);
      },
    );
  }

  getFormattedRentPeriod(): string {
    const startDate = this.previewDetails?.dataStep2?.rentPeriodCoveredStart;
    const endDate = this.previewDetails?.dataStep2?.rentPeriodCoveredEnd;

    if (!startDate || !endDate) return "";

    const formattedStart = this.datePipe.transform(startDate, "mediumDate");
    const formattedEnd = this.datePipe.transform(endDate, "mediumDate");

    return `${formattedStart} – ${formattedEnd}`;
  }

  patchForm() {
    const rentPeriod = this.getFormattedRentPeriod();
    console.log("RENT PERIOD::", rentPeriod);

    console.log(
      "previewDetails.natureOfBusiness:: ",
      this.previewDetails?.dataStep2?.natureOfBusiness,
    );

    console.log(
      "previewDetails.sourceOfIncome:: ",
      this.previewDetails?.dataStep2?.sourceOfIncome,
    );
    this.basicForm.patchValue({
      // STEP 1
      title: this.previewDetails?.dataStep1?.title,
      firstname: this.previewDetails?.dataStep1?.firstname,
      lastname: this.previewDetails?.dataStep1?.lastname,
      nin: this.previewDetails?.dataStep1?.nin,
      middlename: this.previewDetails?.dataStep1?.middlename,
      dob: this.previewDetails?.dataStep1?.dob,
      nationality: this.previewDetails?.dataStep1?.nationality,
      email: this.previewDetails?.dataStep1?.email,
      phone: this.previewDetails?.dataStep1?.phone,
      gender: this.previewDetails?.dataStep1?.gender,
      password: this.previewDetails?.dataStep1?.password,
      confirm_password: this.previewDetails?.dataStep1?.confirm_password,

      // STEP 2
      incomeCategory: this.previewDetails?.dataStep2?.incomeCategory,
      employerName: this.previewDetails?.dataStep2?.employerName,
      incomeRange: this.previewDetails?.dataStep2?.incomeRange,
      natureOfBusiness: this.previewDetails?.dataStep2?.natureOfBusiness,
      sourceOfIncome: this.previewDetails?.dataStep2?.sourceOfIncome?.id,
      totalAnnualIncome: this.previewDetails?.dataStep2?.totalAnnualIncome,
      closestTaxOffice: this.previewDetails?.dataStep2?.closestTaxOffice,
      numberOfVehicles: this.previewDetails?.dataStep2?.numberOfVehicles,
      hasVehicle: this.previewDetails?.dataStep2?.hasVehicle,
      hasProperty: this.previewDetails?.dataStep2?.hasProperty,
      propertyType: this.previewDetails?.dataStep2?.propertyType,
      // CONTACT
      state: this.previewDetails?.dataStep2?.state, // take ID
      lga: this.previewDetails?.dataStep2?.lga, // take ID

      // RENT
      accommodationType: this.previewDetails?.dataStep2?.accommodationType,
      buildingType: this.previewDetails?.dataStep2?.buildingType,
      // rentPeriodCovered: this.previewDetails?.dataStep2?.rentPeriodCovered,
      rentPeriodCovered: rentPeriod,
      periodType: this.previewDetails?.dataStep2?.periodType,
      propertyManagement: this.previewDetails?.dataStep2?.propertyManagement,
      annualRentAmount: this.previewDetails?.dataStep2?.annualRentAmount,

      // LANDLORD
      landlordFullName: this.previewDetails?.dataStep2?.landlordFullName,
      landlordPhoneNumber: this.previewDetails?.dataStep2?.landlordPhoneNumber,
      asin: this.previewDetails?.dataStep2?.asin,
      landlordEmail: this.previewDetails?.dataStep2?.landlordEmail,
      doesLandlordLiveSameApartment:
        this.previewDetails?.dataStep2?.doesLandlordLiveSameApartment ===
        "true",
      landlordAddress: this.previewDetails?.dataStep2?.landlordAddress,

      // LIFESTYLE
      hasPurchasedAsset:
        this.previewDetails?.dataStep2?.hasPurchasedAsset === "true",
      assetItems: this.previewDetails?.dataStep2?.assetItems,
    });

    Object.keys(this.basicForm.controls).forEach((key) => {
      const control = this.basicForm.get(key);
      if (control?.value !== null && control?.value !== "") {
        control.disable();
      }
    });
  }

  screenHeight = window.screen.height - 271; // 1058
  minHeight = "min-height: " + this.screenHeight + "px !important";

  screenHeight2 = window.screen.height - 630; // 428
  minHeight2 = "min-height: " + this.screenHeight2 + "px !important";

  @Output() states = new EventEmitter<{ state: boolean }>();

  submit() {
    this.isLoading = true;
    this.states.emit({ state: true });
    this.onSubmit.emit(this.basicForm.value);
  }

  public getOccupation() {
    this.apiService.LoginGet(`/auth/occupation/all`, {}).subscribe((res) => {
      this.sourceOfIncome = res;
    });
  }

  get ninControl() {
    return this.basicForm?.get("nin");
  }

  isValidatingNin: boolean;
  ninDetails: any;
  ninMismatchError: any;
  isNinValidated: boolean;
  validateNIN() {
    const value = this.basicForm.value;
    this.isValidatingNin = true;
    this.ninMismatchError = null;

    this.isNinValidated = false;
    this.ninDetails = null;
    this.apiService
      .get(`/assessments/nin/match?nin=${value.nin}&asin=${""}`)
      .subscribe(
        (res: any) => {
          if (res.success) {
            this.ninDetails = res.data;
            this.isNinValidated = true;
            alertify.success("NIN Validated Successfully");

            this.basicForm.patchValue({
              ninFirstName: res.this.previewDetails?.first_name,
              ninLastName: res.this.previewDetails?.last_name,
              ninMiddleName: res.this.previewDetails?.middle_name,
              ninPhoneNumber: res.this.previewDetails?.phone_number,
            });
          } else {
            this.ninMismatchError = res.message || "NIN is invalid";
          }
          this.isValidatingNin = false;
        },
        (error) => {
          this.isValidatingNin = false;
        },
      );
  }

  state: any;
  getState() {
    this.apiService.LoginGet("/auth/state/all", {}).subscribe((res) => {
      this.state = res.map((state: any) => ({
        ...state,
        name: toTitleCase(state.name),
      }));
    });
  }

  lgas: any;
  onStateChange() {
    this.getLga(this.basicForm.get("state").value?.id);
    this.basicForm.get("lga").reset();
  }

  getLga(stateId: any) {
    this.apiService
      .LoginGet(`/auth/lga/state/all/${stateId}`, {})
      .subscribe((res) => {
        this.lgas = res;
      });
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.readFile(file).then((result) => {
        this.previewUrl = result;
      });
    }
  }

  readFile(file: File): Promise<string | ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }

  chosenMonthHandler(normalizedMonth: Date, datepicker: any) {
    const ctrlValue = new Date(normalizedMonth);
    ctrlValue.setDate(1); // force day=1
    if (!this.basicForm.value.rentPeriodCoveredStart) {
      this.basicForm.patchValue({ rentPeriodCoveredStart: ctrlValue });
    } else {
      this.basicForm.patchValue({ rentPeriodCoveredEnd: ctrlValue });
    }
    datepicker.close();
  }
}
